// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__hl2wS","errorLogs":"styles_errorLogs__3kKZ7"};